module.exports = __webpack_public_path__ + "img/f6978a0.jpg";